import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createAdvertiseValidationSchema = Yup.object().shape({
  script: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  duration: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  isFullScreen: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  canClose: Yup.string().required(SystemMessage.INPUT_REQUIRED),
});
